<template>
  <div class="codeblock-tabbed">
    <div>
      <div
        class="tabs"
        role="tablist"
      >
        <button
          v-for="tabName in tabNames"
          :key="tabName"
          class="tab"
          type="button"
          role="tab"
          :aria-controls="tabName"
          :aria-selected="selected == tabName"
          @click.prevent="() => select(tabName)"
        >
          {{ tabName }}
        </button>
      </div>
    </div>

    <div :id="selected">
      <slot />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CodeBlock-TabSet',

    // Vue 3 removed $children outright, so the set can no longer reach into its
    // own slot to find its tabs. Each child registers itself on mount instead.
    // The matching injection in CodeBlock defaults to null, so a code block used
    // on its own -- which is every one of them today -- is unaffected.
    provide() {
      return { registerCodeBlockTab: this.registerTab }
    },

    data() {
      return {
        tabs: [],
        selected: null
      }
    },

    computed: {
      tabNames() {
        return this.tabs.map((c) => {
          return c.name
        })
      }
    },

    updated() {
      this.updateTabs()
    },

    methods: {
      // Registration is one-way. A tab removed by v-if would linger in the list;
      // add an unregister pair if a consumer ever needs conditional tabs.
      registerTab(tab) {
        this.tabs.push(tab)
        this.updateTabs()
      },

      select(tabName) {
        this.selected = tabName
        this.updateTabs()
      },

      updateTabs() {
        if (this.tabs.length > 0) {
          this.tabs.forEach((tab) => {
            tab.isVisible = false
          })

          if (this.selected === null) {
            this.selected = this.tabNames[0]
          }

          this.tabs.find((tab) => {
            if (tab.name === this.selected) {
              tab.isVisible = true
            }
          })
        }
      }
    }
  }
</script>
